import AbstractRequestTask from "../AbstractRequestTask";
import device from "../../../devices/device";
import storage from '../../../components/DeviceStorage/DeviceStorage';
import Launcher from '../../apa/Launcher';
import store from "../../../store";


class GetBlockedChannels extends AbstractRequestTask {

  constructor(version = 'v1') {
    super();
    this.version = version;
  }

  getHeaders() {
    return {};
  }

  getUrl() {
    const protocol = 'https';
    const server = Launcher.get("akamai_mfwk");
    const endpoint = 'services/user';
    const version = this.version;
    const apiname = 'controlpin/channels/list';

    return `${protocol}://${server}/${endpoint}/${version}/${apiname}`;
  }

  getParams() {
    const params = super.getParams();
    const user = store.getState().user;
    const user_id = user.user_id || "";
    const user_hash = storage.getItem("user_hash") || "";
    delete params.HKS;
    delete params.api_version;
    
    return Object.assign({}, params, { user_id, user_hash });
  }

  isValid(data) {
    if (data.errors || data.status == 1 || data.response === 'error') {
      return false;
    }
    return true;
  }

  success(data, b) {
    this.resolve(data);
  }
}

export default GetBlockedChannels;



// WEBPACK FOOTER //
// ./src/requests/tasks/user/GetBlockedChannelsTask.js